import { render, staticRenderFns } from "./AIAssistantFloatBtn.vue?vue&type=template&id=6f2edc99&scoped=true"
import script from "./AIAssistantFloatBtn.vue?vue&type=script&lang=js"
export * from "./AIAssistantFloatBtn.vue?vue&type=script&lang=js"
import style0 from "./AIAssistantFloatBtn.vue?vue&type=style&index=0&id=6f2edc99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2edc99",
  null
  
)

export default component.exports